import { useState } from "react";
import { redirect, useNavigate, useParams } from "react-router-dom";
import { HallChalkBoards } from "./HallChalkBoards";
import { HallChalkBoardView } from "./HallChalkBoardsModel";

export type HallChalkBoardsParams<TString> = {
  view: TString
};

export const hallChalkBoardsRouteLoader = async ({ request, params }: { request: any, params: any }) => {
  if (params.view) {
    return null;
  } else {
    // handles default board
    return redirect("vessel-forecast");
  }
}

export const HallChalkBoardsRoute = () => {
  const params = useParams() as Readonly<HallChalkBoardsParams<string>>;
  const navigate = useNavigate();

  const [view, setView] = useState<HallChalkBoardView>(
    params.view as HallChalkBoardView
  )

  const [loading, setLoading] = useState(true);

  const onViewSelect = (view: HallChalkBoardView) => {
    setView(view);
    navigate(`/hall-chalk-boards/${view}`);
    setLoading(true);
  }

  const onLoad = () => {
    setLoading(false);
  };

  return (
    <HallChalkBoards loading={loading} view={view} onViewSelect={onViewSelect} onLoad={onLoad} />
  )
}